/* eslint-disable multiline-ternary */

import { isEmpty } from 'lodash';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { BsTwitterX } from 'react-icons/bs';
import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io';
import {
  EmailIcon,
  EmailShareButton,
  FacebookIcon,
  FacebookShareButton,
  TwitterShareButton
} from 'react-share';
import { KEY_ADS_POSITION } from 'src/components/ads/dynamic-ads';
import { APP_IMG, APP_URL } from 'src/constants';
import { DATALAYER_TYPE, sendDataLayerGlobal, sendDataMeta } from 'src/utils/datalayer/send-datalayer';
import styled from 'styled-components';
import CardV from '../cards/card-v';
import HeadingTag, { KEY_HEADING_TAG } from '../heading/heading-tag';
import Image from '../image';
const DynamicAds = dynamic(import('src/components/ads/dynamic-ads'), { ssr: true });
// const CardV = dynamic(() => import('@components/cards/card-v'));

const GalleryPreview = (props) => {
  const { lastNews, ads, article } = props;
  const [parsedLink, setParsedLink] = useState(null);
  const [title, setTitle] = useState(null);
  const [previewId, setPreviewId] = useState(null);
  const [groupId, setGroupId] = useState();
  const [previewData, setPreviewData] = useState(null);
  const [galleriesLink, setGalleriesLink] = useState(null);
  const [previewIndex, setPreviewIndex] = useState(0);
  const [loadData, setLoadData] = useState(lastNews?.slice(0, 4));
  const [showLoading, setShowLoading] = useState(false);

  const shareLink = `${APP_URL}${parsedLink ?? ''}`;
  const router = useRouter();
  const [closeAd, setCloseBoxAd] = useState(true);

  const handleCloseBoxAd = () => {
    setCloseBoxAd(false);
  };
  const SOCIAL_SHARE = [
    {
      id: 1,
      name: 'facebook',
      icon: (
        <FacebookShareButton url={shareLink}>
          <FacebookIcon size={36} round={true} />
        </FacebookShareButton>
      )
    },
    {
      id: 2,
      name: 'x',
      icon: (
        <TwitterShareButton url={shareLink}>
          <div className='x-sticky-wrapper'>
            <BsTwitterX />
          </div>
        </TwitterShareButton>
      )
    },
    {
      id: 3,
      name: 'email',
      icon: (
        <EmailShareButton url={shareLink}>
          <EmailIcon size={36} round={true} />
        </EmailShareButton>
      )
    }
  ];

  // console.log('GalleryPreview', data);
  // const image = previewData?.file;

  useEffect(() => {
    if (previewId && article?.data) {
      const _data = article.data.find(
        (item) => item.id === previewId
      );
      const _index = article.data.findIndex(
        (item) => item.id === previewId
      );

      setPreviewIndex(_index + 1);
      setPreviewData(_data);
    }
  }, [previewId, article?.data]);

  useEffect(() => {
    try {
      if (lastNews?.length > 4) {
        setShowLoading(true);
      }
      const articleData = localStorage.getItem('article-data');
      const preview = localStorage.getItem('preview');
      if (preview) {
        const previewLink = JSON.parse(preview ?? '');

        setPreviewId(previewLink);
      }
      if (articleData) {
        const data = JSON.parse(articleData ?? '');
        const _link = data.link;
        setTitle(data.title);
        setParsedLink(_link);
        setGalleriesLink(data?.galleriesLink);
        setGroupId(data.group);
      }
    } catch (error) {
      console.log('Error: Please enable website cookies. ' + error);
    }
  }, []);

  const handleRight = (data) => {
    const _data = data?.article?.data;
    const _length = data?.article?.data.length;
    if (typeof window.th_ajax_tracker === 'function') {
      window.th_ajax_tracker('preview-galleries');
    }
    // console.log('GALLERY_PREVIEW #1', _length, groupId, galleriesLink);

    if (Number(_length) === Number(previewIndex)) {
      // const _index = data.article.data.findIndex((item: any) => item.id === _data[Number(_length) - Number(previewIndex)].id);

      // console.log('GALLERY_PREVIEW #2', {
      //     _index,
      //     previewId: _data[Number(_length) - Number(previewIndex)].id,
      //     groupId,
      //     previewData: _data[Number(_length) - Number(previewIndex)],
      //     previewIndex: _length - 1,
      //     link: `${parsedLink}/galleries/${groupId}/${_data[Number(_length) - Number(previewIndex)].id}`
      // });

      setPreviewData(_data[Number(_length) - Number(previewIndex)]);
      setPreviewIndex(previewIndex - Number(previewIndex));
      setPreviewId(_data[Number(_length) - Number(previewIndex)].id);

      if (groupId) {
        if (galleriesLink) {
          router.push(
            `${galleriesLink}/${_data[Number(_length) - Number(previewIndex)]?.id}`
          );
        } else {
          router.push(
            `${parsedLink}/galleries/${groupId}/${_data[Number(_length) - Number(previewIndex)]?.id}`
          );
        }
      }
    }
    if (Number(_length) > Number(previewIndex)) {
      // const _index = data.article.data.findIndex((item: any) => item.id === previewId);
      // console.log('GALLERY_PREVIEW #3', {
      //     _index,
      //     previewId: _data[Number(previewIndex)].id,
      //     groupId,
      //     previewData: _data[Number(previewIndex)],
      //     previewIndex: previewIndex,
      //     link: `${parsedLink}/galleries/${groupId}/${_data[Number(previewIndex)].id}`
      // });

      setPreviewData(_data[Number(_length)]);
      setPreviewIndex(previewIndex);
      setPreviewId(_data[Number(previewIndex)].id);
      if (groupId) {
        if (galleriesLink) {
          router.push(`${galleriesLink}/${_data[Number(previewIndex)]?.id}`);
        } else {
          router.push(
            `${parsedLink}/galleries/${groupId}/${_data[Number(previewIndex)]?.id}`
          );
        }
      }
    }
  };
  const handleLeft = (data) => {
    const _data = data?.article?.data;
    const _length = data?.article?.data.length;
    if (typeof window.th_ajax_tracker === 'function') {
      window.th_ajax_tracker('preview-galleries');
    }
    // console.log('GALLERY_PREVIEW #1', _length, previewIndex, _data);

    if (
      Number(_length) > Number(previewIndex) ||
      Number(_length) === Number(previewIndex)
    ) {
      const _index = data.article.data.findIndex(
        (item) => item.id === previewId
      );
      // console.log('GALLERY_PREVIEW #3', {
      //     _index,
      //     previewId: _data[Number(_index) - 1].id,
      //     groupId,
      //     previewData: _data[Number(_index) - 1],
      //     previewIndex: _index,
      //     link: `${parsedLink}/galleries/${groupId}/${_data[Number(_index) - 1].id}`
      // });

      setPreviewData(_data[Number(_index) - 1]);
      setPreviewIndex(Number(_index) - 1);
      setPreviewId(_data[Number(_index) - 1]?.id);
      if (groupId) {
        if (galleriesLink) {
          router.push(`${galleriesLink}/${_data[Number(_index) - 1]?.id}`);
        } else {
          router.push(
            `${parsedLink}/galleries/${groupId}/${_data[Number(_index) - 1]?.id}`
          );
        }
      }
    }
  };
  const handleLoad = () => {
    setLoadData(lastNews?.slice(0, 6));
    setShowLoading(false);
  };
  const _length = article?.data.length;

  return (
    <>
      <GalleryWrapper id='section-content'>
        <DynamicAds position={KEY_ADS_POSITION.BILLBOARD} data={ads} />

        <div className='main-content'>
          {previewIndex !== 1 ? (
            <div
              className='icon-wrapper --left'
              onClick={() => {
                // ! DATALAYER
                sendDataMeta({
                  id: `อัลบั้ม : ${article?.title} | ${previewId}`,
                  category: 'อัลบั้มภาพ',
                  author: `${article?.created_by ?? ''}`,
                  keyword: `${article?.tags}`,
                  createdAt: `${article?.created_at}`
                });
                sendDataLayerGlobal({
                  type: DATALAYER_TYPE.TRACK_POSITION,
                  router: router?.pathname,
                  section: 'section-content',
                  position: 'ใต้:header',
                  data: {
                    block: '1',
                    title: `${previewId}`,
                    heading: 'ก่อนหน้า',
                    index: Number(previewIndex) - 1
                  }
                });
                handleLeft(props);
              }}
            >
              <IoIosArrowBack />
            </div>
          ) : (
            <div className='icon-wrapper'></div>
          )}
          <div className='container grid-wrapper'>
            <Image
              external={false}
              image={previewData?.file ?? '/default.webp'}
              alt={previewData?.id}
            />
          </div>
          {previewIndex !== _length ? (
            <div
              className='icon-wrapper --right'
              onClick={() => {
                // ! DATALAYER
                sendDataMeta({
                  id: `อัลบั้ม : ${article?.title} | ${previewId}`,
                  category: 'อัลบั้มภาพ',
                  author: `${article?.created_by ?? ''}`,
                  keyword: `${article?.tags}`,
                  createdAt: `${article?.created_at}`
                });
                sendDataLayerGlobal({
                  type: DATALAYER_TYPE.TRACK_POSITION,
                  router: router?.pathname,
                  section: 'section-content',
                  position: 'ใต้:header',
                  data: {
                    block: '1',
                    title: `${previewId}`,
                    heading: 'ถัดไป',
                    index: Number(previewIndex) + 1
                  }
                });
                handleRight(props);
              }}
            >
              <IoIosArrowForward />
            </div>
          ) : (
            <div className='icon-wrapper '></div>
          )}
        </div>

        <div className='block-content container'>
          <div className='top-content'>
            <small>{`รูปภาพที่ ${previewIndex}/${_length ?? 0}`} </small>
            <div id='widget-share' className='share-grid'>
              <div className='text-topic'> แชร์​ </div>
              {SOCIAL_SHARE.map((item, index) => (
                <div className='share item' key={index}>
                  <div
                    key={index}
                    className={`icon-${item.name}`}
                    // ! DATALAYER
                    onClick={() =>
                      sendDataLayerGlobal({
                        type: DATALAYER_TYPE.TRACK_INDEX,
                        router: router?.pathname,
                        section: 'section-content',
                        position: 'ใต้:หัวข้ออัลบั้ม',
                        data: {
                          block: '2',
                          title: item.name,
                          heading: 'แชร์อัลบั้ม',
                          index: index + 1
                        }
                      })
                    }
                  >
                    {item.icon}
                  </div>
                </div>
              ))}

            </div>

          </div>

          <a
            href={
              galleriesLink ? `${galleriesLink}` : `/galleries/${groupId ?? ''}`
            }
            className='link-article'
            onClick={() => {
              sendDataMeta({
                id: `อัลบั้ม : ${article?.title} | ${previewId}`,
                category: 'อัลบั้มภาพ',
                author: `${article?.created_by ?? ''}`,
                keyword: `${article.tags}`,
                createdAt: `${article.created_at}`
              });
              // ! DATALAYER
              sendDataLayerGlobal({
                type: DATALAYER_TYPE.TRACK_INDEX,
                router: router?.pathname,
                section: 'section-content',
                position: 'ใต้:header',
                data: {
                  block: '2',
                  title: `${title}`,
                  heading: 'หัวข้ออัลบั้ม',
                  index: 1
                }
              });
              localStorage.removeItem('article-data');
              localStorage.removeItem('preview');
            }}
          >
            {!isEmpty(title) && <h2 className='line-clamp --3'> {`อัลบั้มรูป : ${title ?? ''}`} </h2>}
          </a>
          <div className='read-article'>

            {parsedLink &&
              <a className='btn-articles' href={parsedLink}>
                อ่านเรื่องนี้
              </a>
            }
          </div>

          <div className='card-list'>
            {loadData && Array.isArray(loadData) && loadData.length > 0 && (
              <div className='widget-lasted container'>
                <div className='section-title'>
                <HeadingTag
                  heading={'อัลบั้มล่าสุด'}
                  type={KEY_HEADING_TAG.SECTION_SECTION}
                  path={null}
                  />
                  </div>
                <div id='block-2' className='galleries-lastnews'>
                  {/* <Carousels slideShow={3} autoplay={true} infinite={true}> */}
                  {loadData.map((item, i) => (
                    <div key={i} className='card-main'>
                      <CardV
                        showPublished={false}
                        showBlurb={false}
                        showFooter={false}
                        path={`/galleries/${item.id}`}
                        data={{
                          ...item,
                          image: item.data?.[0]?.file,
                          link: `/galleries/${item.id}`
                        }}
                        external={false}
                        // ! DATALAYER
                        eventDataLayer={{
                          type: DATALAYER_TYPE.TRACK_POSITION,
                          router: router?.pathname,
                          section: 'section-content',
                          position: 'ใต้:แชร์อัลบั้ม',
                          data: {
                            block: '2',
                            title: `${item.title}`,
                            heading: 'อัลบั้มล่าสุด',
                            index: i + 1
                          }
                        }}
                      />
                    </div>
                  ))}
                </div>
                {/* </Carousels> */}
                <div className='flex-center'>

                  {showLoading && <div className='btn-articles' onClick={() => handleLoad()}>
                    ดูเพิ่มเติม
                  </div>}
                  <div className='btn-articles'>
                    <a
                      href='/galleries'
                      className='link-article'
                      onClick={() => {
                        sendDataMeta({
                          id: `อัลบั้ม : ${article?.title} | ${previewId}`,
                          category: 'อัลบั้มภาพ',
                          author: `${article?.created_by ?? ''}`,
                          keyword: `${article.tags}`,
                          createdAt: `${article.created_at}`
                        });
                        // ! DATALAYER
                        sendDataLayerGlobal({
                          type: DATALAYER_TYPE.TRACK_INDEX,
                          router: router?.pathname,
                          section: 'section-content',
                          position: 'ใต้:header',
                          data: {
                            block: '2',
                            title: `รูปภาพที่ ${previewIndex}/${_length}`,
                            heading: 'อัลบั้มอื่นๆ',
                            index: 1
                          }
                        });
                        localStorage.removeItem('article-data');
                        localStorage.removeItem('preview');
                      }}
                    >
                      อัลบั้มอื่นๆ
                    </a>
                  </div>
                </div>
              </div>
            )}

          </div>
        </div>
      </GalleryWrapper>
      <DynamicAds position={KEY_ADS_POSITION.AD1X1} data={ads} />
                  <div className={`close-box-ads ${!closeAd ? 'close' : 'open'}`}>
                <div onClick={handleCloseBoxAd} className='close-box'>
                  <DynamicAds position={KEY_ADS_POSITION.POSTARTICLE} data={ads} />
                </div>
            </div>
      </>
  );
};
export default GalleryPreview;
const GalleryWrapper = styled.div`
  position: relative;
  z-index: 0;
  overflow: hidden;
  display: block;
  .main-content {
    .resolution-image {
      padding-top: initial;
    }
  }
  .galleries-lastnews {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-gap: 16px;
    margin-top: 20px;
    min-height: 500px;
    img {
        object-fit: cover;
        aspect-ratio: 1/1;
      }
    @media (max-width: 767px) {
      grid-template-columns: repeat(3, 1fr);
      h3 {
        font-size: 14px;
        font-weight: 400;
      }

    }
  }
.read-article {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: flex-end;
}
    .btn-articles {
      cursor: pointer;
    background-color: var(--primary-color);
    padding: 10px 30px;
    border-radius: 10px;
    color: var(--white-color);
    font-size: 18px;
    margin: 0 10px;
    a {
      color: var(--white-color);

    }
  }
    .widget-lasted {
&.container {
  padding: 0;
}
.slick-slide {
    padding: 0 10px;   
}
}
  .icon-wrapper {
    position: static;
    top: 0;
    z-index: 1;
    width: 50px;
    /* transform: translate(50%,0%); */
    /* transform: translate(0%,50%); */
    display: flex;
    align-items: center;

    cursor: pointer;
    height: auto;
    &.--left {
      left: 0;
      right: 0;
      justify-content: flex-start;
    }
    &.--right {
      left: 0;
      right: 0;
      justify-content: flex-end;
    }
    svg {
      font-size: 40px;
      color: var(--white-color);
    }
  }
  .block-content {
    position: relative;
    z-index: 10;
    background: var(--white-color);
    /* position: absolute; */
    /* top: 0;
    right: 0;
    z-index: 2; */
    /* width: 300px; */
    /* height: 80vh; */
    padding: 20px;
    /* border-radius: 30px; */

    .top-content {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      margin-bottom: 5px;
      small {
        display: block;
        text-align: right;
        font-size: 18px;
        color: var(--black-color);
      }

      svg {
        color: var(--black-color);
      }
    }
    .link-article {
      z-index: 5;
      position: relative;
      h2 {
        font-size: 40px;
        color:  var(--black-color);
        margin-bottom: 20px;
        @media (max-width: 767px) {
          font-size: 30px;
          
        }
      }
    }

    .card-item {
      margin-bottom: 5px;
    }
    a {
      cursor: pointer;
    }
    h1 {
      /* padding: 0 1rem; */
      font-size: 22px;
    }
    /* .card-list {
      margin-bottom: 30px;
    }
    @media (max-width: 768px) {
      position: static;
      width: 100%;
      height: auto;
      .card-list {
        overflow: unset;
        max-height: 100%;
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        grid-gap: 10px;
      }
    } */
  }
  .main-content {
    position: relative;
    background-color: var(--primary-color);
    background-image: url(${APP_IMG}/images/bg-galleries.webp);
    background-size: cover;
    min-height: 60vh;
    height: auto;
    padding: 2rem 0;
    display: flex;
    &:before {
      position: absolute;
      z-index: 0;
      top: 0px;
      left: 0;
      content: "";
      /* background-image: url("${APP_IMG}/images/before.webp"); */
      background-size: contain;
      background-repeat: no-repeat;
      width: 100%;
      height: 300%;
    }
    .grid-wrapper {
      display: grid;
      max-width: 85%;
      /* border-radius: 30px; */

      /* grid-template-columns: 100px 1fr 100px; */
      /* padding: 0 11rem; */

      .lazyload-wrapper {
        z-index: 2;
      }
      img {
        /* max-height: 80vh; */
        max-height: 700px;
        height: auto;
        width: 100%;
        object-fit: contain;
        /* border-radius: 30px; */
      }
    }
    @media (max-width: 2560px) {
      .grid-wrapper {
        display: grid;
      }
    }
    @media (max-width: 1024px) {
      .grid-wrapper {
        max-width: 90%;
      }
    }
    @media (max-width: 768px) {
      min-height: 480px;
      height: auto;
      .grid-wrapper {
        display: grid;
        padding: 0;
        /* grid-template-columns: 50px 1fr 50px; */

        /* grid-template-columns: 1fr; */
        /* margin: auto; */
        /* padding: 0 0 0 6rem; */
      }
    }
    @media (max-width: 475px) {
      min-height: 280px;
      height: auto;
    }
  }

  .share-grid {
    display: flex;
    justify-content: flex-start;
    gap: 10px;
    margin: 20px 0;
    .text-topic {
      font-size: 20px;
      font-weight: 600;
      color: var(--black-color)
    }
    .share.item {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: fit-content;
      width: fit-content;
      .--X button {
        display: flex;
        align-items: start;
        height: 43px;
      }
    }
    .x-sticky-wrapper {
      width: 36px;
      height: 36px;
      background-color: #000;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      svg {
        color: #fff;
        font-size: 18px;
      }
    }
  }
`;
